import React, { PropTypes, Component } from 'react';
import Dispatcher from '../../core/Dispatcher';
import withStyles from '../../decorators/withStyles';
import styles from './Steps.css';

@withStyles(styles)
class Steps extends Component {
  static propTypes = {
    step: PropTypes.number
  };

  static defaultProps = {
    step: 1
  };

  render() {
    var step = this.props.step;
    var bgClasses = ['hidden-xs', 'col-md-12', 'bg', 'step_' + step];
    var step_1 = ['step', 'col-md-4', (step == 1) ? 'active' : ''];
    var step_2 = ['step', 'col-md-4', (step == 2) ? 'active' : ''];
    var step_3 = ['step', 'col-md-4', (step == 3) ? 'active' : ''];

    return (
      <div className="Steps row">
        <div className={bgClasses.join(' ')}>
          <div className="row">
            <div className={step_1.join(' ')}>Upload</div>
            <div className={step_2.join(' ')}>Convert</div>
            <div className={step_3.join(' ')}>Download</div>
          </div>
        </div>
      </div>
    );
  }

}

export default Steps;



/** WEBPACK FOOTER **
 ** ./src/components/Steps/Steps.js
 **/